import { isNotDefined } from '@sgme/fp';
import { TimeSeriesGraphFieldMetadata } from 'models/forms/fields';
import type { Action } from 'state/actions';
import { FieldMetadataById } from 'state/common-form/metaData/fields/fields.model';
import type { SelectedCorrelationGraphStateMap } from 'state/quotes/selectedCorrelationGraph/selectedCorrelationGraph.model';
import { removeKey } from 'state/utils/collection';

export function selectedCorrelationGraphReducer(
  state: SelectedCorrelationGraphStateMap = {},
  action: Action,
): SelectedCorrelationGraphStateMap {
  switch (action.type) {
    case 'QUOTE_RECEIVED': {
      const fieldMetadata = action.quote.formResult?.fieldsMetadata;
      const selectedGraph = extractSelectedGraphFromTimeSeriesGraphFieldMetadata(fieldMetadata);
      return selectedGraph ? { ...state, [action.tabId]: selectedGraph } : state;
    }
    case 'BATCH_FORM_ENRICHMENT_RECEIVED': {
      const fieldMetadata = action.fieldsMetadata;
      const selectedGraph = extractSelectedGraphFromTimeSeriesGraphFieldMetadata(fieldMetadata);
      return selectedGraph ? { ...state, [action.formId]: selectedGraph } : state;
    }
    case 'DEFAULT_FORM_RECEIVED': {
      const selectedGraph = extractSelectedGraphFromTimeSeriesGraphFieldMetadata(action.fieldsMetadata);
      return selectedGraph ? { ...state, [action.tabId]: selectedGraph } : state;
    }
    case 'DEFAULT_BATCH_FORM_RECEIVED': {
      const fieldMetadata = action.fieldsMetadata;
      const selectedGraph = extractSelectedGraphFromTimeSeriesGraphFieldMetadata(fieldMetadata);
      return selectedGraph ? { ...state, [action.temporaryFormId]: selectedGraph } : state;
    }
    case 'FORM_RELOADED': {
      if (action.workspace !== 'static') {
        return state;
      }
      const fieldMetadata = action.fieldsMetadata;
      const selectedGraph = extractSelectedGraphFromTimeSeriesGraphFieldMetadata(fieldMetadata);
      return selectedGraph ? { ...state, [action.tabId]: selectedGraph } : state;
    }
    case 'CORRELATION_GRAPH_SELECTED': {
      return { ...state, [action.tabId]: action.value };
    }
    case 'QUOTE_REMOVED':
      if (action.workspace !== 'static') {
        return state;
      }
      return removeKey(state, action.tabId);
    case 'QUOTES_REMOVED':
      return removeKey(state, action.tabId);
    default:
      return state;
  }
}

function extractSelectedGraphFromTimeSeriesGraphFieldMetadata(fieldMetadata?: FieldMetadataById) {
  const timeSeriesGraphFieldMetadata = fieldMetadata?.['TimeSeriesGraph'];
  if (isNotDefined(timeSeriesGraphFieldMetadata)) {
    return undefined;
  }

  return (timeSeriesGraphFieldMetadata as TimeSeriesGraphFieldMetadata).availableGraphs[0];
}
